import React from "react";
import { FlightDetailsInfoMobileUI } from "../../../../../../ui/FlightDetails/FlightDetailsInfo.mobile.ui.js";
import { PlaneTicketReturnIcon, MoneyIncomingIcon } from "@bookingcom/bui-assets-react/streamline";
import { Text } from "@bookingcom/bui-react";
export default function FareRulesInfoWithPartialsMobile(props) {
    const { header, disclaimer, fareRules } = props;
    if (!fareRules?.length)
        return null;
    const iconsMap = {
        CHANGEABLE_TICKET: PlaneTicketReturnIcon,
        CANCELLABLE_TICKET: MoneyIncomingIcon
    };
    return (React.createElement(FlightDetailsInfoMobileUI, null,
        React.createElement(FlightDetailsInfoMobileUI.Title, null, header),
        fareRules?.map((rule) => (React.createElement(FlightDetailsInfoMobileUI.Item, { key: rule.label, svg: iconsMap[rule.featureName] || rule.icon }, rule.label))),
        disclaimer ? React.createElement(Text, { variant: "small_1" }, disclaimer) : undefined));
}
